import React from "react";
import PropTypes from "prop-types";
import { MSpinner } from "components/Shared";
import MCard from "components/Shared/MCard.tsx";
import { Cell, Grid } from "react-md";

class RCTContainer extends React.Component {
    constructor(props) {
        super(props);
        this.generateHomeFeaturesFields = this.generateHomeFeaturesFields.bind(this);
    }

    generateHomeFeaturesFields() {
        const { caseRCT } = this.props;
        if (!caseRCT.homeFeaturesViewModel) return;
        const sections = caseRCT.homeFeaturesViewModel.sections;
        let fields = [];
        sections.map(section => {
            // Only show sections with materials
            if (section.materials?.length) {
                fields.push({
                    label: section.name,
                    value: "",
                    isLabelOnly: true,
                });
                section.materials.map(material => {
                    fields.push({
                        label: material.name,
                        value: material.value,
                        className: "indent"
                    });
                });
            }
        });
        return fields;
    }

    render() {
        const { caseRCT } = this.props;
        if (!caseRCT) {
            return (
                <MSpinner />
            );
        }
        return (
            <Grid>
                {caseRCT.commitDateViewModel && caseRCT.commitDateViewModel.field.value && 
                <Cell size={12} className="md-cell-fit-content">
                    <MCard
                        title="Last Committed"
                        fields={[{
                                    label: caseRCT.commitDateViewModel.field.name,
                                    value: caseRCT.commitDateViewModel.field.value,
                                }]
                            }                        
                    />
                </Cell>}                
                {caseRCT.costEstimateViewModel && <Cell size={12} className="md-cell-fit-content">
                    <MCard
                        title="Cost Breakdown"
                        fields={
                            caseRCT.costEstimateViewModel.fields?.map(field => {
                                return {
                                    label: field.name,
                                    value: field.value,
                                };
                            })
                        }
                    />
                </Cell>}
                {caseRCT.propertyDescriptionViewModel && <Cell size={12} className="md-cell-fit-content">
                    <MCard
                        title="Property Description"
                        className="full-height"
                        fields={
                            caseRCT.propertyDescriptionViewModel.fields?.reduce((fields, field) => {
                                // Only show materials that are present
                                if (field.value && field.value !== "0 %" && field.value !== "0") {
                                    const f = {label: field.name, value: field.value};
                                    if (field.toolTipFields) {
                                        f.tooltip = { 
                                            title: field.toolTipTitle,
                                            fields: field.toolTipFields.map((v) =>  ({label: v.name, value: v.value})),
                                        };
                                    } 
                                    fields.push(f);
                                }
                                return fields;
                            }, [])
                        }
                    />
                </Cell>}
                <Cell size={12} className="md-cell-fit-content">
                    <MCard
                        title="Home Features"
                        className="full-height"
                        fields={this.generateHomeFeaturesFields()}
                    />
                </Cell>
            </Grid>
        );
    }
}

RCTContainer.propTypes = {
    caseRCT: PropTypes.object,
    controlNumber: PropTypes.number.isRequired,
};
export default RCTContainer;